/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Share_App_Logs_DescriptionInputs */

const en_settings_share_app_logs_description = /** @type {(inputs: Settings_Share_App_Logs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export recent diagnostic logs for support.`)
};

const es_settings_share_app_logs_description = /** @type {(inputs: Settings_Share_App_Logs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporta registros de diagnóstico recientes para soporte.`)
};

/**
* | output |
* | --- |
* | "Export recent diagnostic logs for support." |
*
* @param {Settings_Share_App_Logs_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_share_app_logs_description = /** @type {((inputs?: Settings_Share_App_Logs_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Share_App_Logs_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_share_app_logs_description(inputs)
	return en_settings_share_app_logs_description(inputs)
});